import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { readDashboardTabFromSearch, resolveDashboardTabFromPath } from "./dashboardNavigation";

export default function NavigationMonitor() {
  const location = useLocation();
  const previousRef = useRef({
    key: "",
    href: "",
    startedAt: 0,
  });

  useEffect(() => {
    const href = `${location.pathname}${location.search}${location.hash}`;
    const startedAt = performance.now();
    const previous = previousRef.current;

    console.debug("[NAVIGATE] route_change", {
      from: previous.href || null,
      to: href,
      pathname: location.pathname,
      search: location.search,
      stateKeys: location.state && typeof location.state === "object" ? Object.keys(location.state) : [],
      dashboardTab:
        location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/admin-dashboard")
          ? resolveDashboardTabFromPath(location.pathname, readDashboardTabFromSearch(location.search, "assignments"))
          : null,
    });

    let rafId = 0;
    rafId = window.requestAnimationFrame(() => {
      const durationMs = Math.round(performance.now() - startedAt);
      console.debug("[NAVIGATE] route_painted", {
        href,
        durationMs,
      });
    });

    previousRef.current = {
      key: location.key || href,
      href,
      startedAt,
    };

    return () => window.cancelAnimationFrame(rafId);
  }, [location]);

  return null;
}
